import { Tabs } from "antd"
import { useEffect, useState } from "react"
import { ADD, PROG_KEY_TAB_COUNT, NOE, SIP, FUNCTION, FUNC_DETAIL, EDIT, COPY, MOVE, DELETE, CREATE, UPDATE } from "../../../utils/Constants"
import { useDispatch, useSelector } from "react-redux"
import { setPkActionMode, setPkBaseCurrFuncAttrs, setPkCurrFuncAttrs, setPKParentActionMode, setProgKeysCurrData, setProgKeysInstruction } from "../../../store/reducers/ProgKeysReducer"
import _ from "lodash"
import { checkIfAnyModified, findInObjectById, replaceLinkPhAndApplyJLogic, updateObjectById, updateValueById, validateLinks } from "../../../utils/SchemaParseUtils"
import ProgKeysFooter from "./ProgKeysFooter"
import { getAddView, getCustomActionView, getDeleteActionView, getFuncDetailView, getFunctionView, getLabel, getTabClassName, processFuncAttr } from "../../../utils/ProgKeysUtils"
import { formatDictString, getTranslated } from "../../../utils/CommonUtils"
import { validateAllMandatoryAttr } from "../../../utils/ValidationUtils"
import { removeError } from "../../../store/actions/ProgKeysAction"
import confirmModal from "../../common/confirmModal"

const ProgKeysTab = (props) => {

    const [tabItemCount, setTabItemCount] = useState([])
    const [allTabs, setAllTabs] = useState([])
    const [activeTab, setActiveTab] = useState(0)
    const [currCell, setCurrCell] = useState()
    const [tabChildren, setTabChildren] = useState(<></>)
    const [okDisabled, setOkDisabled] = useState(true)
    const [custActionSrc, setCustActionSrc] = useState()
    const [custActionDest, setCustActionDest] = useState()

    const progKeysInstruction = useSelector(state => state.progkeys.progKeysInstruction)
    const progKeysCurrData = useSelector(state => state.progkeys.progKeysCurrData)
    const pkActionMode = useSelector(state => state.progkeys.pkActionMode)
    const pkParentActionMode = useSelector(state => state.progkeys.pkParentActionMode)
    const dict = useSelector(state => state.common.dict)
    const pkCurrFuncAttrs = useSelector(state => state.progkeys.pkCurrFuncAttrs)
    const pkBaseCurrFuncAttrs = useSelector(state => state.progkeys.pkBaseCurrFuncAttrs)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setProgKeysInstruction(getTranslated(dict, "MSG_ADD_PROGKEYS")))
    }, [])

    useEffect(() => {
        setTabChildren(getChildren())
    }, [pkActionMode, allTabs, activeTab, pkCurrFuncAttrs])

    useEffect(() => {
        if (props.progKeyCategory) {
            const countTemp = PROG_KEY_TAB_COUNT.find(item => item.id === props.progKeyCategory)

            if (countTemp)
                if (props.progKeyCategory.includes(SIP)) {
                    setTabItemCount(countTemp["count"])
                } else {
                    setTabItemCount(countTemp[props.selectedAddOn?.slice(-1)]) // slice to get last char i.e. addon number [ 0 | 1 | 2 | 3 ]
                }
        }
    }, [props.progKeyCategory, props.selectedAddOn])

    useEffect(() => {
        progKeysCurrData?.length && setAllTabs(generateCells()) //Generate tab view content and set to state
    }, [tabItemCount, progKeysCurrData])

    useEffect(() => {
        pkCurrFuncAttrs?.attribute && hasAttrChanges() //Control Create/Update key button state 
    }, [pkCurrFuncAttrs])

    useEffect(() => {
        setActiveTab(0) // Reset to default tab on addon change
    }, [props.selectedAddOn])

    useEffect(() => {
        if (pkParentActionMode === ADD) // Reset existing states 
            resetStateToDefault()
    }, [pkParentActionMode])


    // Generate cells grouped by tab with sequential global IDs
    const generateCells = () => {
        let id = 1
        const keys = progKeysCurrData?.find(item => item.id === "keys")?.attribute

        if (!keys) return []

        /* Generate an array of items where `isHardKey` is false.
         The number of items for each tab should match the corresponding value in `tabItemCount`.
         Any items identified as hard keys (`isHardKey === true`) should be skipped and not included in the resulting array. */
        return tabItemCount?.map((count, tabIndex) => {
            const cells = []

            while (cells.length < count && id < keys.length) {

                const foundItem = keys.find((key) => key.keyid === id.toString())

                if (!foundItem) {
                    id++ // skip invalid
                    continue
                }

                const isHardKey = foundItem.hardkeylink
                    ? replaceLinkPhAndApplyJLogic(foundItem.hardkeylink, [
                        { id: "umcsettype", value: props.umcSetType }
                    ])
                    : false

                if (!isHardKey) {
                    cells.push({
                        ...foundItem,
                        tab: tabIndex,
                    })
                }

                id++ // increment always to move to next key
            }

            return cells
        })
    }

    // Generate cells listed with available functions 
    const generateFunctionCells = () => {
        const functions = props.progKeysFuncSchema?.domain.find(item => item.id === "functionid")?.attribute

        return functions
    }

    const handleCellChange = (action, cell) => {
        dispatch(setPkActionMode(action))

        switch (action) {
            case ADD:
                dispatch(setProgKeysInstruction(getTranslated(dict, "MSG_ADD_PROGKEYS")))
                break
            // case EDIT:
            //     break
            case FUNCTION:
                setCurrCell(cell)
                dispatch(setProgKeysInstruction(formatDictString(dict, "MSG_SELECT_FUNCTION", { number: cell.keyid })))
                break
            case FUNC_DETAIL:
                if (pkParentActionMode === ADD) {
                    const updatedData = processFuncAttr(cell)
                    dispatch(setPkCurrFuncAttrs(updatedData))
                    dispatch(setPkBaseCurrFuncAttrs(updatedData))
                    dispatch(setProgKeysInstruction(getTranslated(dict, cell.help)))
                } else {
                    cell.error && dispatch(removeError(cell, progKeysCurrData))
                    dispatch(setPkCurrFuncAttrs(pkParentActionMode === EDIT ? cell.attribute[0] : cell))
                    dispatch(setPkBaseCurrFuncAttrs(pkParentActionMode === EDIT ? cell.attribute[0] : cell))
                    setCurrCell(cell)
                    dispatch(setProgKeysInstruction(getTranslated(dict, cell.attribute[0].help)))
                }
                break
            default:
                return <></>
        }
    }

    // Tab content view for each mode 
    const getChildren = () => {

        if (pkActionMode === ADD || pkActionMode === EDIT) {

            return getAddView(allTabs, activeTab, pkActionMode, handleCellChange)
        } else if (pkActionMode === FUNCTION) {
            const functions = generateFunctionCells()

            return getFunctionView(functions, handleCellChange)
        } else if (pkActionMode === FUNC_DETAIL && pkCurrFuncAttrs) {
            const tempObj = _.cloneDeep(pkCurrFuncAttrs)

            return getFuncDetailView(tempObj, handleSchemaDataChange)
        } else if (pkActionMode.includes(COPY) || pkActionMode.includes(MOVE)) {

            return getCustomActionView(allTabs, activeTab, pkActionMode, handleCustomActions, custActionSrc?.id, custActionDest?.id)
        } else if (pkActionMode.includes(DELETE)) {

            return getDeleteActionView(allTabs, activeTab, pkActionMode, handleDeleteActions)
        } else return <></>
    }

    const handleSchemaDataChange = (attribute, value) => {
        if (value !== undefined) {
            let tempObj = _.cloneDeep(pkCurrFuncAttrs)

            const existingObject = findInObjectById(pkBaseCurrFuncAttrs, attribute.id)
            tempObj = updateValueById(tempObj, attribute.id, value, existingObject)

            tempObj = tempObj?.isLink ? validateLinks(tempObj.obj) : tempObj?.obj

            dispatch(setPkCurrFuncAttrs(tempObj))
        }
    }

    const handleKeySave = async () => {

        const updatedData = await updateObjectById(progKeysCurrData, currCell?.id, (data) => {
            let tempData = _.cloneDeep(data)
            if (tempData) {
                tempData.attribute = [pkCurrFuncAttrs]
                tempData.action = data.action === CREATE ? CREATE : getAction(data)
            }

            return tempData
        })
        props.handleSaveAllKeys(updatedData)
        dispatch(setPKParentActionMode(ADD))
    }

    /* Reset some state values after ProgKeys Save */
    const resetStateToDefault = () => {
        setCustActionSrc()
        setCustActionDest()
    }

    const handleBack = () => {

        const handleConfirmBack = () => {
            dispatch(setPkActionMode(pkParentActionMode === EDIT ? EDIT : FUNCTION))
            pkParentActionMode !== EDIT && dispatch(setProgKeysInstruction(formatDictString(dict, "MSG_SELECT_FUNCTION", { number: currCell.keyid })))
        }

        if (checkIfAnyModified(pkCurrFuncAttrs)) {
            confirmModal({
                title: "MSG_LEAVE_PAGE",
                content: "MSG_LOSE_CONFIG",
                onOk: () => {
                    handleConfirmBack()
                }
            })
        } else {
            handleConfirmBack()
        }
    }

    const getAction = () => {
        if (pkParentActionMode === ADD)
            return CREATE
        else if (pkParentActionMode === EDIT)
            return UPDATE
    }

    // To handle enable/disable of Create/Update key button
    const hasAttrChanges = () => {
        const isModified = pkCurrFuncAttrs.attribute?.some(attr => attr.isModified) // Check any field get modified
        const isValid = validateAllMandatoryAttr(pkCurrFuncAttrs.attribute) // Check for mandatory & regex validation
        setOkDisabled(!(isValid && isModified))
    }

    const handleCustomActions = async (cell, type) => {

        const updatedData = await updateObjectById(progKeysCurrData, cell?.id, (data) => {

            let tempData = _.cloneDeep(data)
            if (tempData) {
                if (type === "SRC") {
                    if (pkActionMode.includes(MOVE))
                        tempData.action = DELETE
                    dispatch(setProgKeysInstruction(`${getTranslated(dict, pkActionMode === COPY ? "LABEL_SEL_COPY_AREA" : "LABEL_SEL_MOVE_AREA")} <<${getLabel(cell.attribute?.length ? cell.attribute[0] : {})}>>`))
                    dispatch(setPkActionMode(pkActionMode + "_ACTIVE"))
                    setCustActionSrc(cell)
                } else {
                    tempData.action = CREATE
                    tempData.attribute = custActionSrc.attribute
                    dispatch(setProgKeysInstruction(""))
                    dispatch(setPkActionMode(pkActionMode.replace("_ACTIVE", "")))
                    setCustActionDest(cell)
                }
            }

            return tempData
        })
        dispatch(setProgKeysCurrData(updatedData))
    }

    const handleDeleteActions = async (cell) => {

        const updatedData = await updateObjectById(progKeysCurrData, cell?.id, (data) => {

            let tempData = _.cloneDeep(data)
            if (tempData) {
                if (tempData.action === CREATE) {
                    delete tempData.attribute
                    delete tempData.action
                } else if (tempData.action === DELETE) {
                    delete tempData.action
                } else
                    tempData.action = DELETE
            }

            return tempData
        })
        dispatch(setProgKeysCurrData(updatedData))
    }


    return <>
        <Tabs
            defaultActiveKey={1}
            type="card"
            size={"small"}
            id={pkActionMode === FUNC_DETAIL && "inner-tab-content"}
            className={getTabClassName(pkActionMode)}
            onChange={(tab) => {
                setActiveTab(Number(tab)) // Convert to Number as tab key is returned as string when tabs selected from dropdown [Tabs not fit into width]
            }}
            activeKey={activeTab}
            items={tabItemCount?.map((item, index) => {
                return {
                    label: props.progKeyCategory?.includes(NOE) ? (index === 0 ? `${getTranslated(dict, "LABEL_PHONE")} (${tabItemCount[index]})` : `${getTranslated(dict, "LABEL_PAGE")} ${index} (${tabItemCount[index]})`) : `${getTranslated(dict, "LABEL_PAGE")} ${index + 1}`,
                    key: index,
                    children: <div className="pk-tab-content" key={index}>
                        <div className="pk-instruction">{progKeysInstruction}</div>
                        <div className="pk-tab-children">
                            {tabChildren}
                        </div>
                    </div>
                }
            })}
        />
        {(pkActionMode === FUNCTION || pkActionMode === FUNC_DETAIL) ? <ProgKeysFooter
            cancelText={pkActionMode === FUNC_DETAIL ? "LABEL_BACK" : ""}
            oKText={pkActionMode === FUNC_DETAIL ? (pkParentActionMode === ADD ? "LABEL_CREATE_KEY" : "LABEL_UPDATE_KEY") : ""}
            okDisabled={okDisabled}
            handleCancel={() => handleBack()}
            handleSave={() => handleKeySave()}
        /> : <></>}
    </>
}

export default ProgKeysTab